/**
 * RecentReflectionsCard - Recent reflection activity
 *
 * Shows the user's most recent reflections with thumbnails and quick access.
 */

import React from 'react';
import { formatRelativeDate } from '../../utils/dateUtils';

function RecentReflectionsCard({ reflections, onViewReflection, onViewAll, timezone }) {
  const getMediaIcon = (reflection) => {
    if (reflection.video_url) return '🎬';
    if (reflection.audio_url) return '🎤';
    if (reflection.text_content) return '📝';
    return '📄';
  };

  return (
    <div className="bento-card bento-card--medium">
      <div className="bento-card-header">
        <h2 className="bento-card-title">
          <span className="bento-card-icon">🕐</span>
          Recent Activity
        </h2>
        {reflections?.length > 0 && (
          <span className="view-all-link" onClick={onViewAll}>
            View All
          </span>
        )}
      </div>
      <div className="recent-reflections-list">
        {(!reflections || reflections.length === 0) ? (
          <div className="recent-empty">
            <p>No reflections yet.</p>
            <p>Start recording your memories!</p>
          </div>
        ) : (
          reflections.slice(0, 4).map(reflection => (
            <div
              key={reflection.id}
              className="recent-reflection-item"
              onClick={() => onViewReflection(reflection)}
            >
              <div className="recent-reflection-thumbnail">
                {reflection.video_thumbnail_url ? (
                  <img
                    src={reflection.video_thumbnail_url}
                    alt=""
                  />
                ) : (
                  getMediaIcon(reflection)
                )}
              </div>
              <div className="recent-reflection-info">
                <div className="recent-reflection-title">
                  {reflection.title || 'Untitled reflection'}
                </div>
                <div className="recent-reflection-date">
                  {formatRelativeDate(reflection.updated_at, timezone)}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default RecentReflectionsCard;
